import { createReducer } from 'redux-starter-kit';
import {
  InvestmentAnalyserType,
  PastPerformanceType,
  CachedDataType
} from './types';
import {
  SET_PERFORMANCE_PERIOD,
  SET_RISK_PERFORMANCE_PERIOD,
  SET_RESEARCH_INVESTMENTS,
  SET_PAST_PERFORMANCE,
  SET_ASSET_ALLOCATION,
  SET_COUNTRY_BREAKDOWN,
  SET_REGIONAL_BREAKDOWN,
  SET_SECTOR_BREAKDOWN,
  SET_RISK_RATINGS,
  SET_SCATTER_CHART_DATA,
  SET_CIP_OPTIONS
} from './actions';
interface InvestmentAnalyserState {
  performancePeriod: string;
  riskPerformancePeriod: string;
  researchInvestments: Array<InvestmentAnalyserType>;
  pastPerformance: PastPerformanceType;
  assetAllocation: CachedDataType;
  countryBreakdown: CachedDataType;
  regionalBreakdown: CachedDataType;
  sectorBreakdown: CachedDataType;
  riskRatings: CachedDataType;
  scatterChartData: any;
  cipOptions: Array<any>;
}

const defaultCachedData = {
  investments: [],
  data: []
};

const INITIAL_STATE: InvestmentAnalyserState = {
  performancePeriod: '5y',
  riskPerformancePeriod: '1y',
  researchInvestments: [],
  pastPerformance: {
    ...defaultCachedData,
    errors: [],
    limits: [],
    tabularData: [],
    earliestDates: {},
    footprints: {}
  },
  assetAllocation: defaultCachedData,
  countryBreakdown: defaultCachedData,
  regionalBreakdown: defaultCachedData,
  sectorBreakdown: defaultCachedData,
  riskRatings: defaultCachedData,
  scatterChartData: [],
  cipOptions: []
};

export default createReducer(INITIAL_STATE, {
  [SET_PERFORMANCE_PERIOD]: (state, { payload }) => {
    state.performancePeriod = payload;
  },
  [SET_RISK_PERFORMANCE_PERIOD]: (state, { payload }) => {
    state.riskPerformancePeriod = payload;
  },
  [SET_RESEARCH_INVESTMENTS]: (state, { payload }) => {
    state.researchInvestments = payload;
  },
  [SET_PAST_PERFORMANCE]: (state, { payload }) => {
    state.pastPerformance = payload;
  },
  [SET_ASSET_ALLOCATION]: (state, { payload }) => {
    state.assetAllocation = payload;
  },
  [SET_COUNTRY_BREAKDOWN]: (state, { payload }) => {
    state.countryBreakdown = payload;
  },
  [SET_REGIONAL_BREAKDOWN]: (state, { payload }) => {
    state.regionalBreakdown = payload;
  },
  [SET_SECTOR_BREAKDOWN]: (state, { payload }) => {
    state.sectorBreakdown = payload;
  },
  [SET_RISK_RATINGS]: (state, { payload }) => {
    state.riskRatings = payload;
  },
  [SET_SCATTER_CHART_DATA]: (state, { payload }) => {
    state.scatterChartData = payload;
  },
  [SET_CIP_OPTIONS]: (state, { payload }) => {
    state.cipOptions = payload;
  }
});
